export default __webpack_public_path__ + "static/task-edit-d283bb5fd8fe9876041ac2e23794e09d.png";